
import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { Link } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import CircularProgress from '@mui/material/CircularProgress';
import TripServices from "../services/externalServices/tripServices";
import { useDispatch, useSelector } from "react-redux";
import { formattedTripTime } from "../utils/dateFormater";



function Trips() {
  const dispatch = useDispatch();
  const {serviceType} = useSelector((state) => state.serviceType.serviceType);
  const [totalTrips, setTotalTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTripType, setSelectedTripType] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const TableHeader = [
    { field: "tripID", headerName: "TripID", minWidth: 220,
    renderCell: (params) => (
      <Link to={`/trip/${params.value}`} className="text-decoration-none text-dark font-weight-bold">
        {params.value}
      </Link>
    )},
    { field: "tripDate", headerName: "Trip Date", minWidth: 120 },
    { field: "tripTime", headerName: "Trip Time", minWidth: 120 },
    { field: "driver", headerName: "Driver", minWidth: 150,
    renderCell: (params) => (
      <Link to={`/riders/${params.row.driverId}`} className="text-decoration-none text-dark font-weight-bold">
        {params.value}
      </Link>
    ) },
    { field: "vehicle_number", headerName: "Vehicle Number", minWidth: 150 },
    { field: "user", headerName: "User", minWidth: 150 },
    { field: "pickup_location", headerName: "PickUp Location", minWidth: 150 },
    { field: "drop_location", headerName: "Drop Location", minWidth: 150 },
    { field: "distance", headerName: "Distance", minWidth: 150 },
    { field: "amount", headerName: "Amount", minWidth: 150 },
    { field: "paymentStatus", headerName: "Payment Status", minWidth: 150 },
    { field: "tripStatus", headerName: "Trip Status", minWidth: 150 },
    {field:"invoiceNumber",headerName:"Invoice Number",minWidth:100}
  ];

  const tripTypes = [
    { value: "", label: "All Trips" },
    { value: "TRIP_STARTED", label: "OnGoing Trips" },
    { value: "CANCELLED", label: "Cancelled Trips" },
    { value: "TRIP_ENDED", label: "Completed Trips" },
    {value:"BOOKED",label:"Booked Trips"}
    
  ];

  useEffect(() => {
    getTotalTrips();
  }, [serviceType]);

  useEffect(() => {
    applyFilters(totalTrips);
  }, [selectedDate, searchQuery, selectedTripType, totalTrips, page, rowsPerPage]);

  const getTotalTrips = async () => {
   const response=await TripServices.getTripswithRiders(serviceType);
    // const response = await axios.get("http://localhost:8080/tripwithrider");
    const validTrips = response.filter((trip) => {
      const parsedDate = new Date(trip.tripDate);
      return !isNaN(parsedDate.getTime()); // Filter out trips with invalid dates
    });
    const sortedTrips = validTrips.sort((a, b) => {
      const dateA = new Date(a.tripDate);
      const dateB = new Date(b.tripDate);
      return dateB.getTime() - dateA.getTime();
    });
    setTotalTrips(sortedTrips);
    applyFilters(sortedTrips);
  };

  const applyFilters = (trips) => {
    let filtered = trips;

    if (selectedDate) {
      filtered = filtered.filter((trip) => {
        const tripDate = dayjs(trip.tripDate);
        return tripDate.isSame(selectedDate, "day");
      });
    }

    // if (searchQuery) {
    //   filtered = filtered.filter(
    //     (trip) =>
    //       trip.riderDetails &&
    //       trip.riderDetails.length > 0 &&
    //       trip.riderDetails[0].first_name &&
    //       trip.riderDetails[0].first_name
    //         .toLowerCase()
    //         .includes(searchQuery.toLowerCase())
    //   );
    // }
    if (searchQuery) {
      filtered = filtered.filter((trip) => {
        const searchString = searchQuery.toLowerCase();
        const driverName = `${trip.riderDetails[0]?.first_name} ${trip.riderDetails[0]?.last_name}`.toLowerCase();
        const tripID = trip._id.toLowerCase();
        return driverName.includes(searchString) || tripID.includes(searchString);
      });
    }

    if (selectedTripType) {
      filtered = filtered.filter((trip) => {
        if (selectedTripType === 'ON_GOING') {
          return trip.status === 'TRIP_STARTED' || trip.status === 'ON_THE_WAY';
        } else {
          return trip.status === selectedTripType;
        }
      });
    }
console.log("filtered trips",filtered);

    setFilteredTrips(filtered);
  };





  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const renderRows = () => {
    
  return filteredTrips.map((trip) => ({
   
    id: trip._id,
    tripID: (
      <Link to={`/trip/${trip._id}`} className="text-decoration-none text-dark font-weight-bold">{trip._id}</Link>
    ),
    tripDate: new Date(trip?.tripDate).toLocaleDateString(),
    // tripTime: new Date(trip?.tripTime).toLocaleTimeString(),
    tripTime:formattedTripTime(trip?.tripTime),
    driver: (
      // <Link to={`/riders/${trip.riderDetails[0]?._id}`} className="text-decoration-none text-dark font-weight-bold">{`${trip.riderDetails[0]?.first_name} ${trip.riderDetails[0]?.last_name}`}</Link>
      <Link
      to={trip.riderDetails[0] ? `/riders/${trip.riderDetails[0]._id}` : "#"}
      className="text-decoration-none text-dark font-weight-bold"
    >
      {trip.riderDetails[0] 
        ? `${trip.riderDetails[0]?.first_name} ${trip.riderDetails[0].last_name}` 
        : ""
      }
    </Link>
    ),
    vehicle_number: trip.riderDetails[0]?.vehicle_number,
    user: `${trip.userDetails[0]?.first_name} ${trip.userDetails[0]?.last_name}`,
    pickup_location: trip.cabRequestDetails[0]?.pickup_location?.title,
    drop_location: trip.cabRequestDetails[0]?.drop_location?.title,
    distance: trip.distance,
    amount: trip.bidDetails[0]?.amount,
    paymentStatus: trip.paymentStatus,
    tripStatus: trip.status,
    invoiceNumber:trip.invoiceNumber


  }));
};

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleTripTypeClick = (tripType) => {
    setSelectedTripType(tripType);
  };

  return (
    <div className="container mt-1">
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      {/* <nav>
        <ol className="breadcrumb d-none d-lg-flex ms-3">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
          </li>
          <li className="breadcrumb-item opacity-50">Trips</li>
        </ol>
      </nav> */}
   <nav>
        <ol className="breadcrumb d-none d-lg-flex">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>
              Home
            </Link>
          </li>
          <li className="breadcrumb-item opacity-50">Trips</li>
        </ol>
      </nav>
      <div className="row g-3 align-items-center" >
        <div className="col">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Search"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </LocalizationProvider>
        </div>

        <div className="col-md-auto">
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <SearchIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
            <TextField
              id="input-with-sx"
              label="Search Driver"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Box>
        </div>
      </div>

      <div className="row justify-content-center mt-3">
        {tripTypes.map((type) => (
          <div className="col-md-auto" key={type.value}>
            <span
              onClick={() => setSelectedTripType(type.value)}
              className={`btn ${
                selectedTripType === type.value
                  ? "btn-info"
                  : "btn-outline-info"
              }`}
              style={{ marginRight: "10px" }}
            >
              {type.label}
            </span>
          </div>
        ))}
      </div>

      <div style={{ height: 440, width: "100%" }}>
  {filteredTrips.length > 0 ? (
    <DataGrid
      rows={renderRows()}
      columns={TableHeader}
      pagination
      pageSize={rowsPerPage}
      rowCount={filteredTrips.length}
      paginationMode="server"
      onPageChange={(newPage) => setPage(newPage)}
      onPageSizeChange={(pageSize) => {
        setRowsPerPage(pageSize);
        setPage(0);
      }}
    />
  ) : (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
      {filteredTrips.length === 0 ? (
        <p>No trips found</p>
      ) : (
        <CircularProgress />
      )}
    </Box>
  )}
</div>

    </Paper>
    </div>
  );
}

export default Trips;

